import { Box, Button, Flex, Heading } from '@chakra-ui/react'
import AddStock from './actions/add-stock'
import EditStock from './actions/edit-stock'
import Icon from '@/components/shared/icons'
import AddUser from './actions/add-user'
import EditUser from './actions/edit-user'
import OpenOrder from './actions/open-order'
import OpenUsersRequest from './actions/open-users-request'
import AddCategory from './actions/add-category'
import EditCategory from './actions/edit-category'
import EditCoupon from './actions/edit-coupon'
import AddCoupon from './actions/add-coupon'
import AddCustomer from './actions/add-customer'
import EditCustomer from './actions/edit-customer'

interface ModalActionsInterface {
	open: Boolean
	close: () => void
	action?: string
	titlePlus?: string
	data?: any
}

const ModalActionsDashboard: React.FC<ModalActionsInterface> = ({
	open,
	close,
	action = 'add-stock',
	titlePlus = '',
	data,
}) => {
	const renderTitle = () => {
		switch (action) {
			case 'add-stock':
				return 'Agregar producto'
			case 'edit-stock':
				return 'Editar producto'
			case 'add-user':
				return 'Agregar usuario'
			case 'edit-user':
				return 'Usuario'
			case 'open-order':
				return titlePlus ? titlePlus : 'Orden #00000'
			case 'open-users-request':
				return 'Responder solicitud'
			case 'add-category':
				return 'Agregar categoria'
			case 'edit-category':
				return 'Editar categoria'
			case 'add-coupon':
				return 'Agregar cupon'
			case 'edit-coupon':
				return 'Editar cupon'
			case 'add-customer':
				return 'Agregar cliente'
			case 'edit-customer':
				return 'Editar cliente'
			default:
				return ''
		}
	}

	const renderContent = () => {
		switch (action) {
			case 'add-stock':
				return AddStock({ close })
			case 'edit-stock':
				return EditStock({ close })
			case 'add-user':
				return AddUser({ close })
			case 'edit-user':
				return EditUser({ close })
			case 'open-order':
				return OpenOrder({ close })
			case 'open-users-request':
				return OpenUsersRequest({ close })
			case 'add-category':
				return AddCategory({ close })
			case 'edit-category':
				return EditCategory({ category: data, close })
			case 'add-coupon':
				return AddCoupon({ close })
			case 'edit-coupon':
				return EditCoupon({ coupon: data, close })
			case 'add-customer':
				return AddCustomer({ close })
			case 'edit-customer':
				return EditCustomer({ close })
			default:
				return null
		}
	}

	return (
		<Flex
			w={{ base: '100vw', md: '50vw', lg: '40vw', xl: '35vw' }}
			h='100vh'
			position='fixed'
			right='0'
			top='0'
			bottom='0'
			bg='white'
			boxShadow='xl'
			zIndex='999'
			p={{ base: `${open ? '4' : '0'}`, md: `${open ? '8' : '0'}` }}
			overflow='auto'
			flexDirection='column'
		>
			<Box
				display='flex'
				justifyContent='space-between'
				alignItems='center'
				mb='8'
				pb='4'
				borderBottom='0.5px solid gray'
			>
				<Heading
					as='h2'
					fontSize={{ base: 'xl', md: '2xl', xl: '3xl' }}
					color='black'
					fontWeight='900'
				>
					{renderTitle()}
				</Heading>
				<Button
					bg='black'
					border='none'
					fontWeight='900'
					size='xl'
					onClick={close}
				>
					<Icon icon='close' size='2xl' color='white' />
				</Button>
			</Box>
			{renderContent()}
		</Flex>
	)
}

export default ModalActionsDashboard
